import { ChakraBox as Box } from "@airhelp/react-ui-components";
import { MAX_GRID_WIDTH } from "config/styleConsts";
import type { ReactNode } from "react";

export const Container = ({ maxWidth = MAX_GRID_WIDTH, children }: { maxWidth?: string; children: ReactNode }) => (
  <Box mx="auto" maxW={maxWidth}>
    {children}
  </Box>
);
